/*
 * @Descripttion: 
 * @version: 
 * @Author: kBank
 * @Date: 2023-03-04 10:21:09
 */
import request from '@/util/request'

// 订单类型
export function orderType(params) {
  return request({
    url: '/sale/api/my-order/order-type',
    method: 'get',
    params
  })
}
// 订单列表
export function orderList(params) {
  return request({
    url: '/sale/api/my-order/list',
    method: 'get',
    params
    // params: qs.stringify(params, {arrayFormat: 'brackets'})
  })
}
// 订单状态
export function orderStoreStatus(params) {
  return request({
    url: '/system/pub/enums/order-shop-status-api',
    method: 'get',
    params
  })
}
//会员店铺统计列表
export function memberStoreSummary(params) {
  return request({
    url: '/sale/api/my-order/member-store-summary',
    method: 'get',
    params
  })
}
//会员店铺统计汇总
export function memberStoreSummarySum(params) {
  return request({
    url: '/sale/api/my-order/member-store-summary-sum',
    method: 'get',
    params
  })
}
// 订单状态
export function orderStatus(params) {
  return request({
    url: '/system/pub/enums/order-status-api',
    method: 'get',
    params
  })
}
// 订单数量
export function orderStoreNum(params) {
  return request({
    url: '/sale/api/my-order/store-num',
    method: 'get',
    params
  })
}
// 订单数量
export function orderNum(params) {
  return request({
    url: '/sale/api/my-order/num',
    method: 'get',
    params
  })
}
// 订单取消
export function cancelOrder(data) {
  return request({
    url: '/sale/api/my-order/cancel/' + data,
    method: 'delete',
  })
}
// 物流状态
export function expressList(id) {
  return request({
    url: '/sale/api/my-order/express/' + id,
    method: 'get',
  })
}
// 校验订单状态
export function payCheck(id) {
  return request({
    url: '/sale/api/my-order/pay-check/' + id,
    method: 'get',
  })
}
// 更新密码
export function confirmReceipt(data) {
  return request({
    url: '/sale/api/my-order/confirm/' + data,
    method: 'put'
  })
}
// 店铺订单列表
export function storeList(params) {
  return request({
    url: '/sale/api/my-order/store-list',
    method: 'get',
    params
    // params: qs.stringify(params, {arrayFormat: 'brackets'})
  })
}
// 店铺待发货订单列表
export function storeSendList(data) {
  return request({
    url: '/scm/api/store-out/list-send?pageNum='+ data.pageNum + '&pageSize=' + data.pageSize,
    method: 'post',
    data
  })
}
// 店铺已发货订单列表
export function storeOrderList(data) {
  return request({
    url: '/scm/api/store-out/list-store-order?pageNum='+ data.pageNum + '&pageSize=' + data.pageSize,
    method: 'post',
    data
  })
}
// 店铺待收货订单列表
export function storeReceiveList(data) {
  return request({
    url: '/scm/api/store-out/list-receive?pageNum='+ data.pageNum + '&pageSize=' + data.pageSize,
    method: 'post',
    data
  })
}
// 店铺待发货订单列表
export function storeStoreHandList(data) {
  return request({
    url: '/scm/api/store-out/list-store-hand',
    method: 'post',
    data
  })
}
//店铺发货
export function storeOrderDelivery(data) {
  return request({
    url: '/sale/api/my-order/store-order-delivery',
    method: 'post',
    data
  })
}
//店铺发货
export function storeSend(data) {
  return request({
    url: '/scm/api/store-out/store-send',
    method: 'post',
    data
  })
}
//店铺收货
export function storeReceive(data) {
  return request({
    url: '/scm/api/store-out/store-receive',
    method: 'post',
    data
  })
}
// 查询店铺订单代发货数量
export function storeNum(params) {
  return request({
    url: '/sale/api/my-order/store-num',
    method: 'get',
    params
  })
}
// 查询店铺订单代发货数量
export function getDelivery(params) {
  return request({
    url: '/system/pub/enums/delivery-list',
    method: 'get',
    params
  })
}